import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import UploaderAllCM from "../../CreateContent/Uploader/UploaderAllCM";
import ImageWithFallback from "../../../UI/ImageFallBack";
import { getAllFilesBys3Key } from "../../../../store/actions/CreateContent/FolderAPI/LessonAPI";
import DropDownButtonUI from "./DropDownButtonUI";
import { createNewSectionTemplateCMRest } from "../../../../store/actions/CreateApp/pagesRestAPIs";
import { re } from "mathjs";

const VariationSectionTemplates =({currentSectionSchema,setCloseVariationPopUp})=>{
  const dispatch = useDispatch();  
      const currentToken = useSelector((state)=>state?.user?.user?.token);
      const user_email = useSelector((state)=>state?.user?.user?.user_email
     );
     const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
     const appId = useSelector((state)=>state?.app?.app?.ID);
     const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
          
                 const [loader , setLoader] =useState({status:false});
     const [snackbarVisible, setSnackbarVisible] = useState(false);
     const [templateType, setTemplateType] = useState("hero");
     const [category, setCategory] = useState("variation");
     const [featuredImage, setFeaturedImage] = useState("");
      
      const [snackbarColor, setSnackbarColor] = useState("#958FDA");
      const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
      const showSnackbar = () => {
       setSnackbarVisible(true);
     };
     
      const hideSnackbar = () => {
       setSnackbarVisible(false);
     };
 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
    const [templateName,setTemplateName]=useState("")
     const [openUploaderPopUp, setOpenUploaderPopUp] = useState(false);
             const [currentFileType, setCurrentFileType] = useState({});
           const [currentFileObject,setCurrentFileObject] = useState({}); 
              const [currentFile,setCurrentFile] = useState(""); 
               
            const [thumbnail, setThumbnail] = useState("");
        
        
              const fireFetchFileLinkByS3Key=(thumbnailKey)=>{
                  
                              
                  setLoader({status:true});
                    const apiData = dispatch(getAllFilesBys3Key({userEmail:user_email?user_email:null,
                    currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,fileKey:thumbnailKey,
                    editType:"getFileListByS3Key"}));
                    /* get response as Promise   */
                    apiData.then(response => {
                      if(response){
                
                        
                        if(response){
                        setCurrentFile(response?.file?.file)
                        setCurrentFileObject(response?.file)
                       
              
                     }else{
                      setResponseMessage("Something Went Wrong...");
                        
                      setSnackbarColor("#958FDA");
                   
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                     }
                        
                     
                     if(response?.logout){
                     
                      setResponseMessage("You are Logged Out!!!");
                        
                      setSnackbarColor("#958FDA");
                   
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                      setTimeout(()=>{
                        dispatch({type:"LOGOUT"});
                  
                      },3000)
                      
                    }
                  /* resetting Login input Fields */
                  
                      }else{
                        setResponseMessage("Something Went Wrong...");
                        
                        setSnackbarColor("#958FDA");
                     
                         
                    setLoader({status:false});
                    
                    setSnackbarVisible(true);
                    setTimeout(()=>{
                      
                      setSnackbarVisible(false);
                     
                       
                    },3000)    }
                  
                    }).catch(error => {
                   
                      //popup of error Info
                      setResponseMessage("Something Went Wrong...");
                        
                      setSnackbarColor("#958FDA");
                   
                       
                  setLoader({status:false});
                  
                  setSnackbarVisible(true);
                  setTimeout(()=>{
                    
                    setSnackbarVisible(false);
                   
                     
                  },3000)
                      console.error(error);
                    });
                   
                    }


  const handleCreateNewSectionTemplateCMRest=()=>{
      
     setLoader({status:true});console.log({templateName:templateName,templateType:templateType
        ,category:category,featuredImage:featuredImage,
        schemaVersion:"",sectionSchema:JSON.stringify(currentSectionSchema),
        
                   postParent:0,userEmail:user_email?user_email:"",
                   currentToken:currentToken?currentToken:"",visibility:"public",status:"active",menuOrder:0,isPrivate:false,
                   editType:"create",appToken:AppToken,appId:appId})
       const apiData = dispatch(createNewSectionTemplateCMRest({templateName:templateName,templateType:templateType
        ,category:category,featuredImage:featuredImage,
        schemaVersion:"",sectionSchema:JSON.stringify(currentSectionSchema),
        
                   postParent:0,userEmail:user_email?user_email:"",
                   currentToken:currentToken?currentToken:"",visibility:"public",status:"active",menuOrder:0,isPrivate:false,
                   editType:"create",appToken:AppToken,appId:appId}
                   ));  
       /* get response as Promise   */
       apiData.then(response => {
         if(response){    
          
           console.log(response)
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
    return(<>
 <div    onClick={()=>setCloseVariationPopUp(false)} className="mockTestV1PopUpVariationOpacityVariation"  style={{cursor:"pointer"}}> </div>
        <div   className="mockTestV1PopUpVariation" style={{borderRadius: '20px'}}> 
        <h2 align="center" >   <span className="" style={{fontSize:"34px"}} >Variation </span> </h2>
      
 
<div style={{overflowY:"auto",overflowX:"hidden",paddingBottom:"50px",height:"280px"}}>
    <div  className="" style={{display:"flex",justifyContent:"space-between"}}>
 <input  className="mockTestVariationTextbox "  style= {{fontSize:"20px",width:"60%"}} placeholder={`Template Variation Name.`} type="text"
  name="reportTextBox" value={templateName} onChange={(e)=>{setTemplateName(e.target.value)}} />
   <DropDownButtonUI activeCard={""} icon={2} title={templateType} 
                     onClickSendObject={(value)=>{if(value){setTemplateType(value)}}}
                      hasDropDown={true} dropDownObject={[{title:"Hero",value:"hero"},{title:"Left section",value:"leftSection"},{title:"Right Section",value:"rightSection"},
                        {title:"Double",value:"double"},{title:"Groove",value:"groove"},{title:"Ridge",value:"ridge"}
                      ]} /> 
 </div>
<div className="" style={{display:"flex",justifyContent:"space-around",background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginLeft:"10px",marginRight:"10px",marginBottom:"10px",paddingLeft:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
        <div style={{"textAlign":"center",
    }}>{
            currentFile?<ImageWithFallback src={currentFile} widthOuter={"170px"} fireOpenEdit ={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}  iconSize={28} setOpenFullImg={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}/>:
          <ImageWithFallback src={currentFile} widthOuter={"170px"} fireOpenEdit ={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}  iconSize={28} setOpenFullImg={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}/>}
   </div>  
   
   
   
    <div style={{"textAlign":"center",
    display:"flex",justifyContent:"center",alignItems:"center",}} >
    <button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}   className=" CoursesPreviewTopBtn"  type="submit"
   > Upload Image </button>
   </div>
   </div>
       <div style={{display:"flex",justifyContent:"center"}}></div>
<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"20px",display:"flex",justifyContent:"center",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}>
<button  onClick={()=>setCloseVariationPopUp(false)}   style={{position:"relative",background:"#ffffff",border:"4px solid rgba(144, 202, 249,1)",color:"rgba(144, 202, 249,1)",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" MocktestVariationBtn"  type="submit"
 > Close </button>
<button  onClick={()=>{handleCreateNewSectionTemplateCMRest()}}   style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" MocktestVariationBtn"  type="submit"
 > Create </button>
</div> 
</div></div>
 {openUploaderPopUp && (
           <UploaderAllCM
             fileTypeObject={[currentFileType]}
            selectedFileObject={currentFileObject} currentFileObject={currentFileObject} setCurrentFileObject={(v)=>{setCurrentFileObject(v);setCurrentFile(v?.file)
               setThumbnail(v?.file_s3_key);setFeaturedImage(v?.file_s3_key)
              
                // handleCreateNewRichContent(currentFileType?.value,currentFileObject)
            }}
             setCloseUploaderPopUp={() => {setOpenUploaderPopUp(false)}}
           />
         )} 
    
<style>{`



 .mockTestVariationTextbox, .mockTestVariationTextbox:hover, .mockTestVariationTextbox:focus{
    background: #f9f9f9;
    box-shadow:var(--shadow-default);
   color:#222;
   padding: 15px;
   margin:10px;outline: #fff;
   border: 3px solid rgba(144, 202, 249,1) !important;
   border-radius: 10px;;
}
  
.MocktestVariationBtn{ 
    box-shadow:0 7px 20px 0 rgba(1,1,1,0.0501);
    font-size: 14px;;cursor: pointer;
    color:rgba(149, 143, 218,0.8);
font-weight:600 !important;width:95px;float: right ;
   cursor: pointer;
padding: 9px 5px ;
font-weight:600 !important;
 border:0px dashed #ffffff ;
    margin:15px;;
    background:#ffffff;border-radius: 10px;;
    text-align: center;
   }
  
.mockTestColoredTextV1Variation {
         animation: background-pan-b24b2865 0.9s linear infinite;
        animation-duration: 0.9s;
        animation-timing-function: linear;
        animation-delay: 0s;
        animation-iteration-count: infinite;
        animation-direction: normal;
        animation-fill-mode: none;
        animation-play-state: running;
        animation-name: background-pan-b24b2865;
 
        animation-timeline: auto;
        animation-range-start: normal;
        animation-range-end: normal;
        background: linear-gradient(to right, #8142e3, #86c2ff);
        -webkit-background-clip: text;
        background-size: 200%;
        -webkit-text-fill-color: transparent;
    }
.mockTestV1PopUpVariationOpacityVariation{position:fixed;top:0px;
        left:0px;
        right:0px;
       
        bottom:0px;
        padding:15px;
        background:rgba(1, 1, 1,0.061);
        z-index:9999999999 !important}
        
        .mockTestV1PopUpVariation{position:fixed;
    left:20%;
    right:20%;
    background: linear-gradient(to right, #fff,#f5f5f5, #fff, #fff);
    top:20%;bottom:20%;
    padding:15px;
    z-index:99999999999 !important;}

/* md */
@media (min-width: 992px) and (max-width: 1199px) {
    .mockTestV1PopUpVariation{position:fixed;top:0px;
        left:20%;
        right:20%;top:22%;
       }}

      /* sm */
@media (min-width: 768px) and (max-width: 991px) {
  .mockTestV1PopUpVariation{position:fixed;top:0px;
                left:20%;
                right:20%;top:22%;
               }} 

/* xs */
@media (max-width: 767px) {
    
    .mockTestV1PopUpVariation{
       
        top:0px!important; height:100% !important;
        left:0%;border-radius: 0px !important;
        right:0%;
        bottom:0%!important;
    }
        }
        `}</style>
    </>)
}
export default VariationSectionTemplates;